import React, { Component } from 'react';
import {
    Card, CardBody, Pagination
} from 'reactstrap';
import PageSpinner from "../../../components/PageSpinner";
import EditProductForm from '../../../components/Admin/Product/EditProduct'


class EditProduct extends Component {
    
    //create a state with productid, isLoading, isSucess
    constructor(props) {
        super(props);
        this.state = {
            productid:props.productid, showBanner: false, message: '', isLoading: false
        };
    }

    render () {
        return (
            <>
            <EditProductForm />
            </>
        )
    }
}
export default  EditProduct